// src/pages/purchase-requisition/components/MaterialDescriptionAutocomplete.jsx
import React, { useState, useEffect } from 'react';
import {
    TextField,
    Autocomplete,
    CircularProgress
} from "@mui/material";
import { database } from "../../../firebase";
import { ref, onValue } from "firebase/database";

function MaterialDescriptionAutocomplete({ value, onChange, error, helperText, freeSolo = true, ...props }) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [isManualInput, setIsManualInput] = useState(false);
    const [isManualInputActive, setIsManualInputActive] = useState(false);

    // Ambil data kode material dari Firebase
    useEffect(() => {
        setLoading(true);
        const materialRef = ref(database, 'db_warehouse/db_ppic/db_config/tb_kode_material');
        
        const unsubscribe = onValue(materialRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const materialList = Object.keys(data).map(key => ({
                    id: key,
                    kode_material: data[key].kode_material || '',
                    deskripsi_material: data[key].deskripsi_material || ''
                }));
                setOptions(materialList);
            } else {
                setOptions([]);
            }
            setLoading(false);
        }, (error) => {
            console.error("Error fetching material data:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

const handleMaterialSelect = (event, newValue, reason) => {
    if (reason === 'clear') {
        // Nilai dihapus (clear button ditekan)
        onChange({
            target: {
                name: props.name,
                value: '',
                isManualInput: false
            }
        });
        
        // Reset kode
        if (props.onCodeChange) {
            props.onCodeChange('');
        }
        setIsManualInput(false);
        setIsManualInputActive(false);
        setInputValue(''); // Reset input value
    } else if (typeof newValue === 'string') {
        // Input manual - kirim sebagai object event yang konsisten
        setIsManualInput(true);
        setIsManualInputActive(true);
        onChange({
            target: {
                name: props.name,
                value: newValue,
                isManualInput: true
            }
        });
        
        // Reset kode jika input manual
        if (props.onCodeChange) {
            props.onCodeChange('');
        }
    } else if (newValue) {
        // Pilihan dari dropdown - kirim object event
        setIsManualInput(false);
        setIsManualInputActive(false);
        onChange({
            target: {
                name: props.name,
                value: newValue.deskripsi_material,
                isManualInput: false
            }
        });
        
        // Juga trigger onChange untuk field terkait
        if (props.onCodeChange) {
            props.onCodeChange(newValue.kode_material);
        }
    }
};

    const handleInputChange = (event, newInputValue, reason) => {
        setInputValue(newInputValue);
        if (newInputValue && !options.some(opt => opt.deskripsi_material === newInputValue)) {
            setIsManualInput(true);
            setIsManualInputActive(true);
        } else if (!newInputValue) {
            setIsManualInputActive(false);
        }
    };

    const shouldShowError = error && !isManualInputActive && !value;

    return (
        <Autocomplete
            freeSolo={freeSolo}
            options={options}
            getOptionLabel={(option) => {
                if (typeof option === 'string') {
                    return option;
                }
                return option.deskripsi_material;
            }}
            value={value ? options.find(option => option.deskripsi_material === value) || value : null}
            onChange={handleMaterialSelect}
            onInputChange={handleInputChange}
            inputValue={inputValue}
            loading={loading}
            sx={{ minWidth: 300 }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    {...props}
                    error={shouldShowError}
                    helperText={shouldShowError ? helperText : ''}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                            </React.Fragment>
                        ),
                    }}
                    size="small"
                />
            )}
            isOptionEqualToValue={(option, value) => {
                if (typeof option === 'string' || typeof value === 'string') {
                    return option === value;
                }
                return option.deskripsi_material === value.deskripsi_material;
            }}
            clearOnBlur={false}
            // Hilangkan tombol clear
            clearOnEscape={false}
            disableClearable={true}
        />
    );
}

export default MaterialDescriptionAutocomplete;